import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function OfficeRemoteCard() {
  const [filter, setFilter] = useState("Weekly");

  const labels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const data = {
    Weekly: {
      office: [
        [100, 20, 40],
        [80, 30, 100],
        [40, 80, 110],
        [150, 170],
        [230, 260, 240],
        [250, 270, 300],
        [260, 300, 330],
      ],
      remote: [
        [220, 230],
        [280, 240, 270],
        [340, 270],
        [300, 250],
        [310, 320],
        [320, 300, 310],
        [360, 320],
      ],
    },
  };

  const current = data[filter];

  return (
    <Card className="orm-card shadow-sm h-100">
      <Card.Body>
        {/* HEADER */}
        <div className="orm-header">
          <div className="orm-header-main">
            <div>
              <h5 className="orm-title">Office Vs Remote</h5>
              <div className="orm-legend">
                <span>
                  <span className="orm-dot orm-office"></span> Office
                </span>
                <span>
                  <span className="orm-dot orm-remote"></span> Remote
                </span>
              </div>
            </div>
          </div>

          <Dropdown align="end">
            <Dropdown.Toggle className="orm-dropdown text-dark">
              <FiCalendar size={14} /> {filter}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setFilter("Weekly")}>
                Weekly
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* CHART */}
        <div className="orm-wrapper">
          <div className="orm-y">
            {[400, 300, 200, 100, 0].map((y) => (
              <span key={y}>{y}</span>
            ))}
          </div>

          <div className="orm-graph">
            {labels.map((day, i) => (
              <div key={i} className="orm-col">
                {current.remote[i].map((val, idx) => (
                  <span
                    key={idx}
                    className="orm-point orm-remote"
                    style={{
                      bottom: `${val * 0.45}px`,
                      left: `${60 + idx * 10}%`,
                    }}
                  />
                ))}

                {current.office[i].map((val, idx) => (
                  <span
                    key={idx}
                    className="orm-point orm-office"
                    style={{
                      bottom: `${val * 0.45}px`,
                      left: `${20 + idx * 10}%`,
                    }}
                  />
                ))}

                <span className="orm-x">{day}</span>
              </div>
            ))}
          </div>
        </div>
      </Card.Body>

      <style>{`

/* CARD */
.orm-card {
  border-radius: 5px;
  border: 2px solid #e5e7eb;
}

/* HEADER */
.orm-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 18px;
  gap: 10px;
  flex-wrap: wrap;
}

.orm-header-main {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.orm-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
}

/* LEGEND */
.orm-legend {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #4b5563;
  flex-wrap: wrap;
}

.orm-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.orm-office { background: #ff6a00; }
.orm-remote { background: #1f2937; }

/* DROPDOWN */
.orm-dropdown {
  font-size: 13px;
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  padding: 6px 10px;
}

/* CHART */
.orm-wrapper {
  display: flex;
  gap: 16px;
  align-items: stretch;
  min-width: 0;
}

/* Y AXIS */
.orm-y {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 260px;
  font-size: 12px;
  color: #9ca3af;
  min-width: 46px;
  flex-shrink: 0;
}

/* GRAPH */
.orm-graph {
  flex: 1;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  height: 240px;
  display: flex;
  position: relative;
  padding-bottom: 20px;
}

.orm-graph::before {
  content: "";
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(
    to top,
    #e5e7eb,
    #e5e7eb 1px,
    transparent 48px
  );
}

/* COLUMN */
.orm-col {
  flex: 1;
  min-width: 40px;
  position: relative;
}

/* POINT */
.orm-point {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

/* X LABEL */
.orm-x {
  position: absolute;
  bottom: -22px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #9ca3af;
}

/* ================= MOBILE ================= */
@media (max-width: 768px) {
  .orm-card {
    margin-top: 10px;
  }

  .orm-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .orm-header > * {
    width: 100%;
  }

  .orm-legend {
    gap: 12px;
    font-size: 12px;
    flex-wrap: wrap;
  }

  .orm-dropdown {
    width: auto;
    max-width: 220px;
  }

  .orm-wrapper {
    flex-direction: row;
    align-items: flex-start;
    overflow-x: auto;
  }

  .orm-y {
    flex-direction: column;
    justify-content: space-between;
    height: 180px;
    width: auto;
    flex-shrink: 0;
  }

  .orm-graph {
    height: 180px;
    min-width: 240px;
    overflow-x: auto;
    padding-bottom: 20px;
  }

  .orm-col {
    min-width: 32px;
  }

  .orm-point {
    width: 7px;
    height: 7px;
  }

  .orm-x {
    font-size: 10px;
    bottom: -18px;
  }
}

      `}</style>
    </Card>
  );
}
